<template>
  <div class="panel newsletter-panel">
    <a-empty description="Newsletter settings coming soon." />
  </div>
</template>

<script setup>
</script>

<style lang="less" scoped>
.panel {
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 16px 20px;
}
.newsletter-panel {
  min-height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
